export default function Snackbar(theme) {
  return {
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      },
      styleOverrides: {
        root: {
          zIndex: theme.zIndex.snackbar,
          position: 'fixed',
          '& .MuiSnackbarContent-root': {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[6],
          },
        },
      },
    },
  };
}
